const updateObject = (oldObject, updatedProperties) =>
({
  ...oldObject,
  ...updatedProperties
})
export default updateObject